/**
 * Created by wuhuping on 2017/7/11.
 */
import JSBridge from './jsBridge'
import store from '../store'
import router from '../router'
export default {
  saveRegisterFailLimitCount(count) {
    window.localStorage.setItem('RegisterFailLimitCount', count)
  },
  saveVerifyCodeSuccessLimitCount(count) {
    window.localStorage.setItem('VerifyCodeSuccessLimitCount', count)
  },
  plusRegisterFailCount() {
    let count = window.localStorage.getItem('RegisterFailCount')
    let maxCount = window.localStorage.getItem('RegisterFailLimitCount')
    if (maxCount) {
      if (!count) {
        window.localStorage.setItem('RegisterFailCount', 1)
      } else {
        if (count < maxCount) {
          window.localStorage.setItem('RegisterFailCount', ++count)
        }
      }
    }
  },
  plusVerifyCodeSuccessCount() {
    let count = window.localStorage.getItem('VerifyCodeSuccessCount')
    let maxCount = window.localStorage.getItem('VerifyCodeSuccessLimitCount')
    if (maxCount) {
      if (!count) {
        window.localStorage.setItem('VerifyCodeSuccessCount', 1)
      } else {
        if (count < maxCount) {
          window.localStorage.setItem('VerifyCodeSuccessCount', ++count)
        }
      }
    }
  },
  checkRegisterIsReachLimit() {
    let count = window.localStorage.getItem('RegisterFailCount')
    let maxCount = window.localStorage.getItem('RegisterFailLimitCount')
    if (maxCount) {
      if (count) {
        return count >= maxCount
      } else {
        return false
      }
    } else {
      return false
    }
  },
  checkVerifyCodeIsReachLimit() {
    let count = window.localStorage.getItem('VerifyCodeSuccessCount')
    let maxCount = window.localStorage.getItem('VerifyCodeSuccessLimitCount')
    if (maxCount) {
      if (count) {
        return count >= maxCount
      } else {
        return false
      }
    } else {
      return false
    }
  },
  isSameWithPreviousAlertID(alertID) {
    let previousAlertID = window.localStorage.getItem('ProjectAlertInfoID')
    window.localStorage.setItem('ProjectAlertInfoID', alertID)
    return parseInt(previousAlertID) === parseInt(alertID)
  },
  hasProjectEntered() {
    let hasEntered = window.sessionStorage.getItem('HasProjectEntered')
    if (!hasEntered) {
      window.sessionStorage.setItem('HasProjectEntered', true)
    }
    return !!hasEntered
  },
  updateDotMaxStep(maxStep) {
    let oldMaxStep = window.sessionStorage.getItem('DotMaxStep')
    if (oldMaxStep) {
      maxStep = Math.max(maxStep, oldMaxStep)
    }
    window.sessionStorage.setItem('DotMaxStep', maxStep)
  },
  clearDotMaxStep() {
    window.sessionStorage.removeItem('DotMaxStep')
  },
  fetchDotMaxStep() {
    let maxStep = window.sessionStorage.getItem('DotMaxStep')
    if (maxStep) {
      return maxStep
    } else {
      return 0
    }
  },
  getType(obj) {
    // tostring会返回对应不同的标签的构造函数
    let toString = Object.prototype.toString
    let map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object'
    }
    if (obj instanceof Element) {
      return 'element'
    }
    return map[toString.call(obj)]
  },
  deepClone(data) {
    let type = this.getType(data)
    let obj
    if (type === 'array') {
      obj = []
    } else if (type === 'object') {
      obj = {}
    } else {
      // 不再具有下一层次
      return data
    }
    if (type === 'array') {
      for (let i = 0, len = data.length; i < len; i++) {
        obj.push(this.deepClone(data[i]))
      }
    } else if (type === 'object') {
      for (let key in data) {
        obj[key] = this.deepClone(data[key])
      }
    }
    return obj
  },
  signClick() {
    // if (!store.getters.isLogin) {
    //   router.push({'name': 'quickLogin'})
    //   return
    // }
    let url
    if (store.getters.isLogin) url = `https://activity.xycredit.com.cn/signin/?activityCode=sign_xyqb&platform=xyqb&envm=1&channel=sign_xyqb&childchan=001&bannerPhone=${store.getters.phone}&bannerUserId=${store.state.user.userInfo.id}`
    else url = `https://activity.xycredit.com.cn/signin/?activityCode=sign_xyqb&platform=xyqb&envm=1&channel=sign_xyqb&childchan=001`
    window.location.href = url
    JSBridge.showAndHideNativeHeader(true);
    // ios
    JSBridge.sendApplyPageUrlToNative()
    // android
    if (window.android && window.android.callAndroid) {
      window.android.callAndroid(window.location.href, this.title, {})
    }
  },
  // 判断是否是微信
  isWeiXin() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  },
  // url 参数拆分并返回数组
  urlParamesSplit(url) {
    let parameterArr = url.substring(url.lastIndexOf('?') + 1).split('&')
    let parames = {}
    for (let i = 0; i < parameterArr.length; i++) {
      let parameSplit = parameterArr[i].split('=')
      if (parames[parameSplit[0]] === 'jumpUrl') parames[parameSplit[0]] = parameSplit.length < 2 ? null : parameSplit[1]
      else parames[parameSplit[0]] = parameSplit.length < 2 ? null : decodeURIComponent(parameSplit[1])
    }
    return parames
  },
  GetQueryString(name, url) {
    var _url = url || window.location.search
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = _url.substr(1).match(reg)
    if (r !== null) return unescape(r[2]); return null
  }
}



// WEBPACK FOOTER //
// ./src/tools/globalHelper.js